import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("rect", {
  width: "20",
  height: "20",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.95338 18.1289C1.69876 17.9081 1.60223 17.5556 1.70882 17.2358L3.8432 10.8327H9.99935C10.4596 10.8327 10.8327 10.4596 10.8327 9.99935C10.8327 9.53911 10.4596 9.16602 9.99935 9.16602H3.84319L1.70882 2.76288C1.60223 2.44313 1.69876 2.09065 1.95338 1.86982C2.20801 1.64898 2.57059 1.60327 2.87206 1.754L17.8721 9.25401C18.1544 9.39517 18.3327 9.68372 18.3327 9.99936C18.3327 10.315 18.1544 10.6036 17.8721 10.7447L2.87206 18.2447C2.57059 18.3954 2.20801 18.3497 1.95338 18.1289Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}